module.exports = __webpack_public_path__ + "img/A.5cf29464.png";